var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmtyTopscore = function SvgEmtyTopscore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.9%",
    y: "-18.3%",
    width: "165.9%",
    height: "165.9%",
    filterUnits: "objectBoundingBox",
    id: "EmtyTopscore_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.191597465 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-5.3%",
    width: "110.6%",
    height: "110.5%",
    filterUnits: "objectBoundingBox",
    id: "EmtyTopscore_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "39.463%",
    x2: "72.917%",
    y2: "85.916%",
    id: "EmtyTopscore_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B3B3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmtyTopscore_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CCC",
    fillRule: "nonzero",
    cx: 40.84,
    cy: 40.84,
    r: 37.65
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#888787",
    strokeWidth: 1.5,
    cx: 41,
    cy: 41,
    r: 36.421
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#D5D5D5",
    strokeWidth: 3.6,
    cx: 41,
    cy: 41,
    r: 39.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmtyTopscore_svg__b)",
    transform: "translate(12.444 12.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.58 46.521C6.202 42.308 2.388 44.08.5 39.493c-1.888-4.587 2.16-5.441 2.387-11.658C3.114 21.618-.97 22.3.906 16.818c1.875-5.482 5.544-2.277 9.673-6.428 4.13-4.151 1.311-7.02 6.277-9.544 4.966-2.525 5.747 2.287 11.338 2.287 5.591 0 6.535-4.546 11.187-2.686 4.652 1.86 2.864 5.926 6.963 9.943 4.1 4.017 7.78 1.616 9.743 6.428 1.964 4.811-2.118 7.034-2.118 12.258 0 5.224 3.836 6.251 2.118 10.417-1.717 4.166-5.104 2.057-8.934 6.115-3.83 4.058-1.305 7.568-5.988 9.699-4.683 2.13-6.599-1.716-12.137-1.453-5.538.262-6.125 4.47-10.964 2.547-4.84-1.924-3.108-5.667-7.485-9.88Z",
    fill: "url(#EmtyTopscore_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#888787",
    fillRule: "nonzero",
    cx: 28.397,
    cy: 28.397,
    r: 19.144
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D6CF",
    d: "M25.09 18.556h-4.4l-5.134 6.6h7.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9D9B",
    d: "m41.956 25.156-5.133-6.6h-4.4l2.2 6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B2",
    d: "M34.623 25.156h7.333l-13.2 15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDA",
    d: "M22.89 25.156h-7.334l13.2 15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFAEAC",
    d: "m25.09 18.556-2.2 6.6h11.733l-2.2-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBC8",
    d: "m28.756 40.556-5.866-15.4h11.733z"
  }))))));
};
export default SvgEmtyTopscore;